import { memo, type PropsWithChildren, type ReactNode, useMemo } from 'react';

import Item from './components/Item/index.tsx';
import ItemLink from './components/ItemLink.tsx';
import { ItemSeparator } from './components/ItemSeparator.tsx';
import { ItemsList } from './components/ItemsList/index.tsx';
import ItemSubLink from './components/ItemSubLink/index.tsx';
import { usePuzzleNavigationContext } from './context.tsx';
import { Wrapper } from './styled.ts';

type PuzzleNavProps = PropsWithChildren<{
  className?: string;
  header?: ReactNode;
  companySelect?: ReactNode;
  searchInput: ReactNode;
  timer?: ReactNode;
  footer?: ReactNode;
  isCollapsedNav: boolean;
  collapseMainNav: () => void;
  mobileHeaderHeight: number;
}>;

const PuzzleNav = ({
  children,
  className,
  footer,
  header,
  companySelect,
  searchInput,
  timer,
  isCollapsedNav,
  collapseMainNav,
  mobileHeaderHeight,
}: PuzzleNavProps) => {
  const providerValues = useMemo(
    () => ({
      isCollapsedNav,
      collapseMainNav,
    }),
    [isCollapsedNav, collapseMainNav],
  );

  return (
    <usePuzzleNavigationContext.Provider value={providerValues}>
      <Wrapper className={className} $isCollapsedNav={isCollapsedNav} data-testid='puzzle-nav-wrapper'>
        <ItemsList
          header={header}
          companySelect={companySelect}
          searchInput={searchInput}
          timer={timer}
          footer={footer}
          mobileHeaderHeight={mobileHeaderHeight}>
          {children}
        </ItemsList>
      </Wrapper>
    </usePuzzleNavigationContext.Provider>
  );
};

const PuzzleNavMemo = memo(PuzzleNav);

const PuzzleNavWrapper = Object.assign(PuzzleNavMemo, {
  Item,
  ItemSubLink,
  ItemLink,
  ItemSeparator,
});

export default PuzzleNavWrapper;
